
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './Styles/global.css';
import Home from './Pages/Home';
import Recipes from './Pages/Recipes';
import LoginModal from './Components/Auth/LoginModal';
import RegisterModal from './Components/Auth/RegisterModal';
import { AuthProvider, useAuth } from './Context/AuthContext';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Eindgebruiker from './Pages/Eindgebruiker';
import Ahmedewerker from './Pages/EmployeeManager';
import ChefKok from './Pages/ChefManager';
import Contentbeheerder from './Pages/ContentManager';
import Contact from "./Pages/Contact";
import Over from "./Pages/Over";

function App() {
    const [activeModal, setActiveModal] = useState('login'); // 'login', 'register', or null

    const openLoginModal = () => {
        setActiveModal('login');
    };

    const openRegisterModal = () => {
        setActiveModal('register');
    };

    return (
        <div className="App">
            <AuthProvider>
                <MainContent openLoginModal={openLoginModal} openRegisterModal={openRegisterModal} activeModal={activeModal} setActiveModal={setActiveModal} />
            </AuthProvider>
        </div>
    );
}

const MainContent = ({ openLoginModal, openRegisterModal, activeModal, setActiveModal }) => {
    const { currentUser } = useAuth();

    return (
        <>
            <Routes>
                <Route path="/login" element={<LoginModal isOpen={activeModal === 'login'} onClose={() => setActiveModal(null)} setRegisterOpen={openRegisterModal} />} />
                <Route path="/register" element={<RegisterModal isOpen={activeModal === 'register'} onClose={() => setActiveModal(null)} />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/Contact" element={<Contact/>} />
                <Route path="/" element={<Home openLoginModal={openLoginModal} openRegisterModal={openRegisterModal} />} />
                <Route path="/Eindgebruiker" element={<ProtectedRoute allowedRoles={['eindgebruiker']} element={<Eindgebruiker />} />} />
                <Route path="/EmployeeManager" element={<ProtectedRoute allowedRoles={['ah-medewerker']} element={<Ahmedewerker />} />} />
                <Route path="/ChefManager" element={<ProtectedRoute allowedRoles={['chef kok']} element={<ChefKok />} />} />
                <Route path="/Over" element={<Over />} />
                <Route path="/ContentManager" element={<ProtectedRoute allowedRoles={['contentbeheerder']} element={<Contentbeheerder />} />} />
            </Routes>
            {!currentUser && (
                <>
                    <LoginModal isOpen={activeModal === 'login'} onClose={() => setActiveModal(null)} setRegisterOpen={openRegisterModal} />
                    <RegisterModal isOpen={activeModal === 'register'} onClose={() => setActiveModal(null)} />
                </>
            )}
        </>
    );
};

export default App;
